<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a Therapy Session
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-autocomplete
                ref="patient"
                outlined
                v-model="form.patient_id"
                :items="patientItems"
                label="Patient *"
                prepend-inner-icon="mdi-account-circle"
                clearable
                :error-messages="errors.patient_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                ref="device"
                outlined
                v-model="form.device_id"
                :items="deviceItems"
                label="Device *"
                prepend-inner-icon="mdi-medical-bag"
                clearable
                :error-messages="errors.device_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                ref="procedure"
                outlined
                v-model="form.procedure_id"
                :items="procedureItems"
                label="Procedure"
                prepend-inner-icon="mdi-clipboard-list"
                clearable
                :error-messages="errors.procedure_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                ref="status"
                outlined
                v-model="form.status"
                :items="statusItems"
                label="Status"
                prepend-inner-icon="mdi-check-circle"
                clearable
                :error-messages="errors.status"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.start_time"
                outlined
                label="Start Time"
                prepend-inner-icon="mdi-clock-start"
                type="time"
                :error-messages="errors.start_time"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.end_time"
                outlined
                label="End Time"
                prepend-inner-icon="mdi-clock-end"
                type="time"
                :error-messages="errors.end_time"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.duration"
                outlined
                label="Duration (minutes)"
                prepend-inner-icon="mdi-timer"
                type="number"
                min="0"
                step="1"
                :error-messages="errors.duration"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.distance_covered"
                outlined
                label="Distance Covered (meters)"
                prepend-inner-icon="mdi-map-marker-distance"
                type="number"
                min="0"
                step="1"
                :error-messages="errors.distance_covered"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.unweighting_percentage"
                outlined
                label="Unweighting Percentage (%)"
                prepend-inner-icon="mdi-weight-lifter"
                type="number"
                min="0"
                max="100"
                step="1"
                :error-messages="errors.unweighting_percentage"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.lifted_weight"
                outlined
                label="Lifted Weight (kg)"
                prepend-inner-icon="mdi-dumbbell"
                type="number"
                min="0"
                step="0.1"
                :error-messages="errors.lifted_weight"
              ></v-text-field>
            </v-col>
            <v-col sm="12">
              <v-text-field
                v-model="form.session_notes"
                outlined
                label="Session Notes (ID)"
                prepend-inner-icon="mdi-note-text"
                type="number"
                min="0"
                step="1"
                hint="Enter a numeric ID reference for session notes"
                :error-messages="errors.session_notes"
              ></v-text-field>
            </v-col>
            <v-col sm="12">
              <v-switch
                v-model="form.is_active"
                :label="`Session is ${form.is_active ? 'Active' : 'Inactive'}`"
                color="primary"
                inset
              ></v-switch>
            </v-col>
          </v-row>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save Therapy Session
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "@/axios";
export default {
  name: "TherapySessionCreatePage",
  data() {
    return {
      form: {
        is_active: true,
        patient_id: null,
        device_id: null,
        procedure_id: null,
        start_time: null,
        end_time: null,
        duration: null,
        distance_covered: null,
        unweighting_percentage: null,
        lifted_weight: null,
        session_notes: null,
        status: null,
      },
      patientItems: [],
      deviceItems: [],
      procedureItems: [],
      statusItems: [
        {
          id: 1,
          text: "Completed",
          value: 1,
        },
        {
          id: 2,
          text: "Stopped",
          value: 2,
        },
        {
          id: 3,
          text: "Emergency Stopped",
          value: 3,
        },
      ],
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters['errors/getErrors'];
    }
  },
  mounted() {
    this.form.company_id = this.company.id;
    console.log(this.companyId);
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=therapy_session`)
        .then((masters) => {
          masters = masters.data;
          
          // Patients
          if (masters.patients) {
            masters.patients.forEach((patient) => {
              this.patientItems.push({
                id: patient.id,
                text: `${patient.first_name} ${patient.last_name}`,
                value: patient.id,
              });
            });
          }
          
          // Devices
          if (masters.devices) {
            masters.devices.forEach((device) => {
              this.deviceItems.push({
                id: device.id,
                text: `${device.model_name} (${device.serial_number})`,
                value: device.id,
              });
            });
          }
          
          // Procedures
          if (masters.procedures) {
            masters.procedures.forEach((procedure) => {
              this.procedureItems.push({
                id: procedure.id,
                text: procedure.name,
                value: procedure.id,
              });
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          if (error.response && error.response.status === 401) {
            //window.location.href = "/auth/login";
          }
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/therapy_sessions", this.form);
        this.isLoading = false;
        this.$router.push("/therapy_sessions");
      } catch (e) {
        // alert("error");
        this.isLoading = false;
      }
    },
  },
};
</script>